import {
  ProductsListingStore,
  ProductsListingActions,
  ProductsListingPaginationType,
  ProductsListingFiltersType,
} from './types';

export const defaultState: ProductsListingStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  errorFilters: null,
  isLoadingFilters: false,
  isLoadedFilters: false,
  products: [],
  productCategory: null,
  designers: [],
  pagination: {
    offset: 0,
    limit: 20,
  },
  filters: {
    productSubcategories: [],
    designers: [],
    locationTypes: [],
  },
  filterData: {
    productSubcategories: [],
    designers: [],
    locationTypes: [],
  },
  isFiltersDataLoading: false,
  searchResultsCount: 0,
  loadedListing: {},
};

const reducer = (
  state: ProductsListingStore = defaultState,
  action: {
    type: ProductsListingActions;
    payload?: any;
    pagination?: ProductsListingPaginationType;
    searchResultsCount?: number;
    categorySlug?: string;
    filters?: ProductsListingFiltersType;
  }
): ProductsListingStore => {
  const {
    FetchFiltersBegin,
    FetchFiltersError,
    FetchFiltersSuccess,
    FetchCategoryBegin,
    FetchCategoryError,
    FetchCategorySuccess,
    SearchBegin,
    SearchSuccess,
    SearchError,
  } = ProductsListingActions;

  switch (action.type) {
    case FetchFiltersBegin:
      return {
        ...state,
        isLoadingFilters: true,
        errorFilters: null,
        isLoadedFilters: false,
        isFiltersDataLoading: true,
      };

    case FetchFiltersSuccess:
      return {
        ...state,
        errorFilters: null,
        isLoadingFilters: false,
        isLoadedFilters: true,
        filterData: action.payload.filterData,
        isFiltersDataLoading: false,
      };
    case FetchFiltersError: {
      return {
        ...state,
        isLoadingFilters: false,
        errorFilters: action.payload,
        isLoadedFilters: true,
        isFiltersDataLoading: false,
      };
    }
    case FetchCategoryBegin:
      return {
        ...state,
        // isFiltersDataLoading: true,
      };

    case FetchCategorySuccess:
      return {
        ...state,
        productCategory: action.payload.productCategory,
        // filterData: action.payload.filterData,
        // isFiltersDataLoading: false,
      };
    case FetchCategoryError: {
      return {
        ...state,
        // isFiltersDataLoading: false,
      };
    }

    case SearchBegin:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };

    case SearchSuccess:
      const newState = {
        ...state,
        products:
          action.pagination.offset === 0 ? action.payload : [...state.products, ...action.payload],
        searchResultsCount: action.searchResultsCount,
        // categorySlug: action.categorySlug,
        filters: action.filters,
        pagination: action.pagination,
        isLoading: false,
        isLoaded: true,
      };
      const categoryProduct = { ...newState };
      delete categoryProduct.loadedListing;
      newState.loadedListing[newState.productCategory?.slug] = categoryProduct;
      return newState;

    case SearchError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
